import { render } from "./App.vue?vue&type=template&id=9fdc4fce"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9fdc4fce&lang=scss"
import "./App.vue?vue&type=style&index=1&id=9fdc4fce&lang=css"
script.render = render

export default script